import type { FindingPdfEdit } from "@repo/shared/findingChanges";

export interface ChangeDiscussion {
  proposalId: string;
  index: number;
  edit: FindingPdfEdit;
}
export const changeDiscussionKey = (context: ChangeDiscussion) =>
  `[PDF change ${context.proposalId}/${context.index + 1}]`;
export const changeDiscussionPrefix = (context: ChangeDiscussion) =>
  `${changeDiscussionKey(context)}\nPage ${context.edit.beforePage}${context.edit.afterPage !== context.edit.beforePage ? ` → ${context.edit.afterPage}` : ""} · ${context.edit.section}\n\n`;
export const belongsToChange = (text: string, context: ChangeDiscussion) =>
  text.replace(/^@Inspector\s+/i, "").startsWith(`${changeDiscussionKey(context)}\n`);
/** Keep the human page/section reference in the timeline, without exposing storage identifiers. */
export const displayChangeComment = (text: string) =>
  text.replace(/^\[PDF change [^\]\n]+\/\d+\]\n/, "");
